module.exports = __webpack_public_path__ + "img/shoes_img.60f02db5.png";